/**
 * Emails API Service
 * Handles all email-related API calls
 */

import apiClient from './index.js';

export class EmailsApi {
  /**
   * Get list of emails
   */
  static async getEmails(token) {
    return apiClient.get('/create/v1/emails', token);
  }

  /**
   * Get email details by relId (for tier emails)
   * @param {string} token - Auth token
   * @param {string} tier - Tier relId
   */
  static async getEmailDetails(token, tier) {
    return apiClient.get(`/create/v1/emails/details?tier=${tier}`, token);
  }

  /**
   * Add a new email
   * @param {string} token - Auth token
   * @param {Object} emailData - Email data
   */
  static async addEmail(token, emailData) {
    return apiClient.post('/create/v1/emails', token, emailData);
  }

  /**
   * Update email
   * @param {string} token - Auth token
   * @param {string} emailId - Email ID
   * @param {string} type - Update type (e.g., 'tier', 'email', 'note')
   * @param {string} data - Update data
   */
  static async updateEmail(token, emailId, type, data) {
    return apiClient.patch('/create/v1/emails', token, { type, data, emailId });
  }

  /**
   * Delete email
   * @param {string} token - Auth token
   * @param {string} emailId - Email ID
   */
  static async deleteEmail(token, emailId) {
    return apiClient.delete(`/create/v1/emails?id=${emailId}`, token);
  }

  /**
   * Delete all emails (bulk delete)
   * @param {string} token - Auth token
   */
  static async deleteAllEmails(token) {
    return apiClient.delete('/create/v1/emails?bulk=true', token);
  }
}

export default EmailsApi;
